import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDecimal
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";

export default [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString("ConfigurationParameter/Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    type: new InMemoryString(
      "ConfigurationParameter/Translations[]/LanguageCode"
    ),
    visible: false,
    allowVisibilityChange: false,
  }),
  // new InMemoryHeader({
  //     title: "globals.description",
  //     type: new InMemoryString("ConfigurationParameter/Translations[]/Description", {
  //         getString: (item) => translate2(item, "Description")
  //     }),
  //     sortable: true,
  //     visible: true,
  //     allowVisibilityChange: true,
  //     searchable: true,
  // }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("ConfigurationParameter/Translations[]/Name", {
      getString: (item) => translate2(item.ConfigurationParameter, "Name"),
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    type: new InMemoryString("ConfigurationParameter/Name"),
    visible: false,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.parameter_type",
    type: new InMemoryString("ConfigurationParameter/ParameterType"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.applies_on",
    type: new InMemoryString("ConfigurationParameter/UsedInFormulaType", {
      getString: (item) =>
        i18n.t("enums." + item.ConfigurationParameter.UsedInFormulaType),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.value",
    type: new InMemoryString("ConfigurationParameterValue/Value", {
      getString: (item, type) => {
        let v = item.ConfigurationParameterValue.Value;
        if (item.ConfigurationParameter.ParameterType === "Amount") {
          const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
          });
          return formatter.format(v);
        } else if (item.ConfigurationParameter.ParameterType === "Percentage") {
          return (parseFloat(v) * 100).toFixed(2) + "%";
        } /* else if (item.TypeDescription === "Constant") {} */ else {
          return v;
        }
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString(
      "ConfigurationParameter/CoverageIdentity/Current/Translations[]/Name",
      {
        getString: (item) => {
          //console.log("parameter", item);
          return item.ConfigurationParameter.CoverageIdentity
            ? translate2(
                item.ConfigurationParameter.CoverageIdentity.Current,
                "Name"
              ) +
                " (" +
                translate2(
                  item.ConfigurationParameter.CoverageIdentity.Current,
                  "Description"
                ) +
                ")"
            : "";
        },
      }
    ),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Employer",
    type: new InMemoryString(
      "ConfigurationParameter/Identity/Employer/Translations[]/Name",
      {
        getString: (item) => {
          //console.log("parameter", item);
          return item.ConfigurationParameter.Identity
            ? translate2(item.ConfigurationParameter.Identity.Employer, "Name")
            : "";
        },
      }
    ),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.members_management.Store",
    type: new InMemoryString(
      "ConfigurationParameter/Identity/Store/Translations[]/Name",
      {
        getString: (item) => {
          //console.log("parameter", item);
          return item.ConfigurationParameter.Identity
            ? translate2(item.ConfigurationParameter.Identity.Store, "Name")
            : "";
        },
      }
    ),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.contribution_category",
    type: new InMemoryString("ContributionCategory/Category"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "views.coverage.funded_percentage",
    type: new InMemoryDecimal("ConfigurationParameterValue/FundedPercentage", {
      getString: (item, type) => {
        let v = item.ConfigurationParameterValue.FundedPercentage;
        if (v===null || v===undefined) {
          return "";
        }
        
        return (parseFloat(v) * 100).toFixed(2) + "%";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
